let Animation = {
  animateItem(container, item, startAngle, endAngle, duration, run, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        startValue: startAngle,
        endValue: endAngle,
        duration: duration,

        // linear movement
        // easing: function(t, b, c, d) { return c*t/d + b; },
        easing: fabric.util.ease.easeOutExpo,

        onChange: function (angle) {
          item.angle = angle;
          item.updatePos(that.center);
          if (run) {
            that.FabricCanvas.renderAll();
          }
        },
        onComplete: function () {
          that.FabricCanvas.renderAll();
          if (run && typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
          // return that.down;
        }
      });
    })();
  },

  animateItem2(container, item, startAngle, endAngle, duration, run, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        startValue: startAngle,
        endValue: endAngle,
        duration: duration,

        // linear movement
        easing: function (t, b, c, d) { return c * t / d + b; },
        // easing: fabric.util.ease.easeOutExpo,

        onChange: function (angle) {
          item.angle = angle;
          item.updatePos(that.center);
          if (run) {
            that.FabricCanvas.renderAll();
          }
        },
        onComplete: function () {
          that.FabricCanvas.renderAll();
          if (run && typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
          // return that.down;
        }
      });
    })();
  },

  animateItem3(container, item, startPos, endPos, duration, run, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        startValue: startPos,
        endValue: endPos,
        duration: duration,
        easing: function (t, b, c, d) { return c * t / d + b; },
        onChange: function (angle) {
          item.img.set({
            top: angle
          }).setCoords();
          if (run) {
            that.FabricCanvas.renderAll();
          }
        },
        onComplete: function () {
          that.FabricCanvas.renderAll();
          if (run && typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
        }
      });
    })();
  },

  animateLine(container, item, p1, p2, duration, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        startValue: p1.y,
        endValue: p2.y,
        duration: duration,

        // linear movement
        easing: function (t, b, c, d) { return c * t / d + b; },

        onChange: function (value) {
          let y = value;
          let x = ((y - p1.y) * (p2.x - p1.x)) / (p2.y - p1.y) + p1.x;
          item.setPos(x, y);
          that.FabricCanvas.renderAll();
        },
        onComplete: function () {
          that.FabricCanvas.renderAll();
          if (typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
        }
      });
    })();
  },

  animateCircle(container, item, r1, r2, duration, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        startValue: r1,
        endValue: r2,
        duration: duration,
        // linear movement
        easing: function (t, b, c, d) {
          return  (b+t*c/d) ; 
        },

        onChange: function (value) {
          item.setRadius(value);
         // that.FabricCanvas.renderAll();
        },
        onComplete: function () {
          //that.FabricCanvas.renderAll();
          if (typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
        }
      });
    })();
  },
  animateCircleToDraw(container, r1, r2, duration, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        duration: duration,
        startValue: r1,
        endValue: r2,
        // linear movement
        easing: function (t, b, c, d) {
          return  (b+t*c/d) ; 
        },
        onChange: function (value) {
          that.circle.setRadius(value);
        },
        onComplete: function () {
          //that.FabricCanvas.renderAll.bind(that.FabricCanvas);
          if (typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
        }
      });
    })();
  },
  animateItemChangeSize(container, r1, r2,counter, lengthItems,duration,run, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        duration: duration,
        startValue: r1,
        endValue: r2,
        // linear movement
        easing: function (t, b, c, d) {
          return  (b+t*c/d) ; 
        },
        onChange: function (value) {
          let item=that.items[counter];
          that.items[counter].circleRadius = value;
           /* if (item.angle < 0) {
              let tmp = that.items[lengthItems - 1].angle + that.items[lengthItems - 1].a / 2;
              item.angle = tmp + item.a / 2;
            }*/
            that.items[counter].updateSizes(that.items[counter].img.width, that.items[counter].img.height);
            that.items[counter].img.set({
              left: item.pos.x,
              top: item.pos.y,
              scaleX: item.scale,
              scaleY: item.scale,
              angle: item.pos.rotation
            });
            that.items[counter].updatePos(that.center);
            if (run) {
              //that.FabricCanvas.renderAll();
            }
           // that.items[counter].img.perPixelTargetFind = true;
        },
        onComplete: function () {
          if(run)
          that.FabricCanvas.renderAll();
          if (run&&  typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
        }
      });
    })();
  },
  animateItemChangeSizeDown(container, r1, r2,counter, lengthItems,duration,run, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        duration: duration,
        startValue: r1,
        endValue: r2,
        // linear movement
        easing:fabric.util.ease.easeOutExpo,
        onChange: function (value) {
          that.items[counter].circleRadius = value;
          let item=that.items[counter];
          that.items[counter].updateSizes(that.items[counter].img.width, that.items[counter].img.height);
          that.items[counter].img.set({
            left: item.pos.x,
            top: item.pos.y,
            scaleX: item.scale,
            scaleY: item.scale,
            angle: item.pos.rotation
          });
          that.items[counter].updatePos(that.center);

          if (run) {
            that.FabricCanvas.renderAll();
          }
        },
        onComplete: function () {
          if(run)
          that.FabricCanvas.renderAll();
          if (run&&  typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
        }
      });
    })();
  },
  animateCircleToDraw2(container, r1, r2, duration, callback) {
    let that = container;
    (function animate() {
      fabric.util.animate({
        duration: duration,
        startValue: r1,
        endValue: r2,
        // linear movement
        easing: function (t, b, c, d) {
          return  (b+t*c/d) ; 
        },
        onChange: function (value) {
          that.circle.setRadius(value);
          let i = that.items.length;
          for(var counter=0;counter<(i-1);counter++){
            let item=that.items[counter];
            that.items[counter].circleRadius = value;
            if (item.angle < 0) {
              let tmp = i === 0 ? 0 : that.items[i - 1].angle + that.items[i - 1].a / 2;
              item.angle = tmp + item.a / 2;
            }
            that.items[counter].updateSizes(that.items[counter].img.width, that.items[counter].img.height);
            that.items[counter].img.set({
              left: item.pos.x,
              top: item.pos.y,
              scaleX: item.scale,
              scaleY: item.scale,
              angle: item.pos.rotation
            });
            that.items[counter].updatePos(that.center);
            that.items[counter].img.perPixelTargetFind = true;
          }
        },
        onComplete: function () {
          that.FabricCanvas.renderAll();
          if (typeof callback === 'function') {
            callback();
          }
        },
        abort: function () {
        }
      });
    })();
  }
}

export default Animation;
